module.exports = __webpack_public_path__ + "img/ottoman.edfa5ca6.png";